import SearchIcon from '@mui/icons-material/Search';
import { useState } from 'react';
function SearchBar(){
    const [name, setName] = useState("");
    return(
        <>
            <div class="flex-container">
            <div style={{height:'50px' ,width:'100%',paddingTop:"10px", paddingRight:"10px", transform: "scale(1.8)"}} className="svg_icons"><SearchIcon/></div>
            <div >
                <input 
                   className={"searchBar font-bold text-black"}
                   style={{height:'50px' ,width:'700px',borderRadius:"16px"}} 
                   type="text" 
                   value={name}
                   onChange={(e) => setName(e.target.value)} />
            </div>
            </div>
        </>
    )
}

export default SearchBar